
/**
 * SKU Search Fix - v5
 *
 * 1. Numeric-only SKU:
 *    - Do NOT add quotes
 *    - Use options[prefix]=none
 *
 * 2. Alphanumeric SKU:
 *    - Add quotes for exact match
 *    - Use options[prefix]=none
 *
 * 3. Predictive search:
 *    - Block predictive API for SKU searches
 */

(function() {
  'use strict';

  /* ============================================
     SKU PATTERN
  ============================================ */

  function isSkuPattern(query) {
    if (!query) return false;

    var trimmed = query.trim();

    if (!trimmed) return false;
    if (trimmed.indexOf(' ') !== -1) return false;
    if (trimmed.length < 3) return false;

    // Already quoted
    if (
      trimmed.charAt(0) === '"' &&
      trimmed.charAt(trimmed.length - 1) === '"'
    ) {
      return true;
    }

    // SKU must contain at least one number
    return /^[A-Za-z0-9_\-]+$/.test(trimmed) && /\d/.test(trimmed);
  }


  /* ============================================
     NUMERIC ONLY SKU
  ============================================ */

  function isNumericSku(query) {
    if (!query) return false;

    var trimmed = query.trim();

    // Remove quotes if user/search URL already has them
    trimmed = trimmed.replace(/^"+|"+$/g, '');

    return /^\d+$/.test(trimmed);
  }


  /* ============================================
     CLEAN SKU
  ============================================ */

  function cleanSku(query) {
    if (!query) return '';

    return query
      .trim()
      .replace(/^"+|"+$/g, '');
  }


  /* ============================================
     PART 1:
     SEARCH RESULTS PAGE FORM SUBMIT
  ============================================ */

  function attachToForms() {

    var forms = document.querySelectorAll(
      'form[action*="/search"]'
    );

    forms.forEach(function(form) {

      if (form.dataset.skuFixAttached) return;

      form.dataset.skuFixAttached = 'true';

      form.addEventListener('submit', function() {

        var input = form.querySelector('input[name="q"]');

        if (!input || !input.value) return;

        var originalValue = input.value.trim();

        if (!isSkuPattern(originalValue)) {
          return;
        }

        var sku = cleanSku(originalValue);

        /*
         * IMPORTANT:
         *
         * Numeric SKU:
         * 6936624
         *
         * NOT:
         * "6936624"
         */
        if (isNumericSku(sku)) {

          input.value = sku;

        } else {

          /*
           * Alphanumeric SKU:
           * ABC123
           *
           * becomes:
           * "ABC123"
           */
          input.value = '"' + sku + '"';
        }


        /* ========================================
           PREFIX NONE
        ======================================== */

        var prefixInput = form.querySelector(
          'input[name="options[prefix]"]'
        );

        if (!prefixInput) {

          prefixInput = document.createElement('input');

          prefixInput.type = 'hidden';
          prefixInput.name = 'options[prefix]';

          form.appendChild(prefixInput);
        }

        prefixInput.value = 'none';

      });

    });
  }


  /* ============================================
     PART 2:
     PREDICTIVE SEARCH
  ============================================ */

  function interceptFetch() {

    if (window.__skuFixFetchPatched) return;

    window.__skuFixFetchPatched = true;

    var originalFetch = window.fetch;

    window.fetch = function(input, init) {

      try {

        var url =
          typeof input === 'string'
            ? input
            : (input && input.url);

        if (
          url &&
          url.indexOf('/search/suggest') !== -1
        ) {

          var urlObj = new URL(
            url,
            window.location.origin
          );

          var query = urlObj.searchParams.get('q');

          if (
            query &&
            isSkuPattern(query)
          ) {

            /*
             * Do not call Shopify predictive search
             * for SKU queries.
             */

            return Promise.resolve(
              new Response('', {
                status: 200,
                headers: {
                  'Content-Type': 'text/html'
                }
              })
            );
          }
        }

      } catch (e) {
        // Fail silently
      }

      return originalFetch.call(
        this,
        input,
        init
      );
    };
  }


  /* ============================================
     PART 3:
     HIDE PREDICTIVE RESULTS FOR SKU
  ============================================ */

  function hideNoResultsForSku() {

    var searchInputs =
      document.querySelectorAll(
        'input[name="q"]'
      );

    searchInputs.forEach(function(input) {

      if (
        input.dataset.skuFixInputAttached
      ) {
        return;
      }

      input.dataset.skuFixInputAttached = 'true';


      input.addEventListener(
        'input',
        function() {

          var value =
            input.value.trim();

          var resultsContainer =
            document.querySelector(
              '[data-predictive-search-results], ' +
              '#predictive-search-results, ' +
              '.predictive-search__results'
            );


          if (!resultsContainer) {
            return;
          }


          if (isSkuPattern(value)) {

            resultsContainer.style.display =
              'none';

          } else {

            resultsContainer.style.display =
              '';
          }

        }
      );

    });
  }


  /* ============================================
     INIT
  ============================================ */

  function init() {

    attachToForms();

    interceptFetch();

    hideNoResultsForSku();

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }


  /* Shopify dynamic sections */

  document.addEventListener(
    'shopify:section:load',
    function() {

      attachToForms();

      hideNoResultsForSku();

    }
  );

})();